module.exports = __webpack_public_path__ + "img/icon.7e840cdf.png";